import { ImArrowDown } from "react-icons/im";
import myResume from '../../../assets/CV/Exchange Teller CV .pdf';
import img from '../../../assets/img/sharif_up (2).png';
import './Banner.css';
import Typewrite from './Typewrite';

const Banner = () => {
  // const url = 'https://drive.google.com/file/d/1PhUwmgIvnamfQLackrm7zuFUUziN09q6/view?usp=sharing';
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch(myResume).then(response => {
        response.blob().then(blob => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = 'Download CV.pdf';
            alink.click();
        })
    })
}

    return (
        <div   className=" container  ">
        <div class=" lg:grid-cols-2 grid justify-between sm:grid-cols-1 text-white">

          <div 
             data-aos="fade-up"
             data-aos-anchor-placement="top-bottom"
             data-aos-duration="1500"
          class=" benner-content order-last md:order-last md:mt-5 mt-20 w-4/5">

           <Typewrite></Typewrite>

            <p className="text-left justify-center mt-1"> 
          I am a Mern stack web developer. I am passionate about building excellent web application that improves user experience. Basically I'm expertise in React.js, javascript,
          I am also familiar with Node.js, Express.js, and Mongodb.
  
          <br></br>
         
            <button onClick={onButtonClick} style={{backgroundColor:"#19AB78",color:"white",border:"none"}} className='btn mt-2 '>
            Download CV <small className='inline-block'><ImArrowDown/></small>  </button>
            </p>

          </div>
          <div 
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
          data-aos-duration="1500"
          class="w-3/4 md:order-first  order-first bannerPhato ml-8  ">
          <img className='bannerPhoto' src={img} alt="" />
          </div>
        </div>
      </div>
    );
};

export default Banner;